module.exports = __webpack_public_path__ + "img/img2.51a9e457.jpg";